import React from 'react';
import ReactDOM from 'react-dom';
import AppRoute from "./routes";


import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./static/css/app.css";

import { Provider } from "react-redux";


import store from "./store/configureStore";

const App = () => (
  <Provider store={store}>
    <AppRoute />
  </Provider>
);

ReactDOM.render(<App />, document.getElementById("root"));




// WEBPACK FOOTER //
// ./src/index.js